import React from "react";
import { Button, Col, FormControl, FormLabel, Row } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { BaseBean, RestReportBean } from "../ds/client_ds.js";
import {
  CustomerSearchCriteria,
  FabricStyleBean,
  FabricStyleSearchCriteria,
  FabricStyleSKUBean,
  OpenPickTicketInquiryCriteriaBean,
  PullBulkPickTicketInfoBean,
  PullBulkPickTicketSummaryInquiryDetailRequest,
  PullBulkPickTicketSummaryResultBean,
  RestCustomerListRequest,
  RestFabricStyleListBeanRequest,
  RestPageListBean,
  RestReadRequest,
} from "../ds/ds.js";
import {
  AlertToolBox,
  ColumnDefinition,
  DataGridColumnDefinition,
  DatePickerComponent,
  EditableDataGrid,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupCustomerModule,
  PopupFabricModule,
  PopupPickTicketModule,
  PopupSalesModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager";
import { CustomerService } from "../services/CustomerService.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { ReportService } from "../services/ReportService.js";
import CustomTable from "../gui_components/CustomTable.js";
class PrintBulkPickTicketMaintenanceDetails extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.customerCodeRef = React.createRef();
    this.state = {
      pageTitle: "Print Bulk PickTicket Maintenance",
      isShowExitButton: true,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      error_list: [],
      isShowAlert: false,
      alertType: "",
      alertMessage: [],
      isPickTicketDatasFound: false,
      pickTicketDataList: [],
      criteria: new OpenPickTicketInquiryCriteriaBean(),
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      fabricLookupHandler: null,
      colorLookupHandler: null,
      customerLookupHandler: null,
      colorList: [],
      fabricStyleData: new FabricStyleBean(),
      isShowColorLookup: false,
      fabricPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricList: true,
      fabricColourPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricColorList: true,
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerList: true,
      isShowFabricStyleModule: false,
      isShowCustomerModule: false,
      isShowSalesModule: false,
      isShowPickTicketModule: false,
      isShowLookup: true,
      isDisableFields: false,
      moduleForPopup: [],
      selectedLineList: [],
      isShowPrintButton: false,
      isShowFetchButton: true,
      isShowSelectButton: false,
      is3PL: false,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    this.initLookupHandlers();
    let criteria = this.state.criteria;
    criteria.pickTicketSelectionStatus = 2;
    this.setState({ criteria: criteria });
  }
  initLookupHandlers = () => {
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "Fabric Style"
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer"
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "No Lines Selected";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  fetch = (e) => {
    if (e.detail == 1) {
      this.hideAlertCallBack();
      this.loadPage();
    }
  };
  loadPage = () => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    this.loadPullBulkPickTicketList(criteria);
  };
  loadPullBulkPickTicketList = (listRequest) => {
    if (SecurityAccessManager.BulkPickTicketInquiry_IsAccessible()) {
      ReportService.inquirePullBulkPickTicketSummaryInquiryDetails(
        listRequest,
        this.loadPullBulkPickTicketPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadPullBulkPickTicketPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.result != null) {
      let openPickTicketInfos = new Array();
      if (!isEmptyArray(response.data.result.openPickTicketInfos)) {
        openPickTicketInfos = response.data.result.openPickTicketInfos;
        this.setState({
          isShowPrintButton: true,
          isShowSelectButton: true,
        });
      }
      this.setState({
        isPickTicketDatasFound: true,
        pickTicketDataList: openPickTicketInfos,
        isShowClearCriteriaButton: false,
        isShowResetButton: true,
        isShowColorLookup: false,
        isShowLookup: false,
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  errorCallBack = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error" + error);
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowFabricStyleModule: isOpen,
      isShowCustomerModule: isOpen,
      isShowPickTicketModule: isOpen,
      isShowSalesModule: isOpen,
      moduleForPopup: [],
    });
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowLinePopup: isShowPopup,
    });
  };
  clearCriteria = () => {
    let criteria = new OpenPickTicketInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    criteria.fabricStyleName = "";
    criteria.pickTicketSelectionStatus = 2;
    this.setState({
      criteria: criteria,
      isShowColorLookup: false,
    });
    this.hideAlertCallBack();
  };
  reset = () => {
    let criteria = new OpenPickTicketInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    criteria.fabricStyleName = "";
    criteria.pickTicketSelectionStatus = 2;
    this.setState({
      criteria: criteria,
      isPickTicketDatasFound: false,
      pickTicketDataList: new Array(),
      isDisableFields: false,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isShowLookup: true,
      isShowPrintButton: false,
      isShowSelectButton: false,
    });
    this.hideAlertCallBack();
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmpty(fabricStyleCode)) {
      this.state.showAutoCompleteList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = "";
      criteria.fabricStyleName = "";
      criteria.fabricStyleColorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
        isShowColorLookup: false,
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetFabricStyleDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria.fabricStyleCode = fabricStyle.code;
        criteria.fabricStyleName = fabricStyle.description;
        let colors = fabricStyle.colors;
        let finalColorList = [];
        colors.map((ent) => {
          let colorBean = new BaseBean();
          colorBean.code = ent.fabricStyleColorCode;
          colorBean.description = ent.fabricStyleColorName;
          finalColorList.push(colorBean);
        });
        this.setState({ colorLookupHandler: null });
        if (finalColorList != null) {
          let colorLookupHandler = new GenericAttributeLookupHandler(
            finalColorList,
            "Color"
          );
          this.setState({
            colorLookupHandler: colorLookupHandler,
            isShowColorLookup: true,
            criteria: criteria,
            colorList: finalColorList,
            fabricStyleData: fabricStyle,
            isShowProgressBarPopup: false,
            progressLoadingText: "",
          });
        }
      }
    }
  };

  readandsetFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    FabricStyleService.readFabricStyle(
      input,
      this.readandsetFabricStyleDetailResponse,
      this.errorCallBack
    );
  };
  readFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByFabricCodeResponse,
      this.errorCallBack
    );
  }
  readByFabricCodeResponse = (response) => {
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData.map((fabricStyle) => {
        let simpleItemBean = {
          code: fabricStyle.fabricStyleCode,
          description: fabricStyle.fabricStyleName,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      fabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  fabricEnterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    if (!isEmpty(fabricStyleCode)) {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: this.state.is3PL ? "read Item" : "read Fabric",
      });
      this.readandsetFabricStyleDetail(fabricStyleCode);
      this.setState({ fabricPageListForAutoCompleteList: new Array() });
    }
  };
  displayAutoCompleteFabricList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteList });
  };
  onFabricColourCodeChange = (e) => {
    this.state.showAutoCompleteFabricColorList = true;
    let fabricStyleColorCode = e.target.value;
    let showAutoCompleteFabricColorList =
      this.state.showAutoCompleteFabricColorList;
    if (isEmpty(fabricStyleColorCode)) {
      this.state.showAutoCompleteFabricColorList = false;
      let showAutoCompleteFabricColorList =
        this.state.showAutoCompleteFabricColorList;
      let criteria = this.state.criteria;
      criteria.fabricStyleColorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricColorList: showAutoCompleteFabricColorList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "fabricStyleColorCode" &&
      showAutoCompleteFabricColorList === true &&
      fabricStyleColorCode !== ""
    ) {
      this.readFabricColourBySearchString(e.target.value);
    }
  };
  readFabricColourBySearchString(searchString) {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    if (!isEmpty(fabricStyle)) {
      fabricStyle.fabricStyleSkus.map((sku) => {
        if (
          sku.fabricStyleCode == criteria.fabricStyleCode &&
          sku.fabricStyleColorCode == searchString
        )
          skuBean = sku;
      });
    }
    criteria.fabricStyleColorCode = searchString;
    let colorList = this.state.colorList;
    let simpleAutoCompleteColorList = new Array();
    colorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      fabricColourPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricColourEnterKeyEventHandler = (e) => {
    let fabricStyleColourCode = e.target.value;
    this.fabricStyleColorSelected(fabricStyleColourCode);
    this.setState({ fabricColourPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricColorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricColorList: showAutoCompleteList });
  };
  fabricStyleColorSelected = (fabricStyleColorCode) => {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    if (!isEmpty(fabricStyle)) {
      fabricStyle.fabricStyleSkus.map((sku) => {
        if (
          sku.fabricStyleCode == criteria.fabricStyleCode &&
          sku.fabricStyleColorCode == fabricStyleColorCode
        )
          skuBean = sku;
      });
    }
    criteria.fabricStyleColorCode = fabricStyleColorCode;
    this.setState({ criteria: criteria });
  };
  customerCodeOnChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let criteria = this.state.criteria;
      criteria.customerCode = "";
      criteria.customerName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCustomerList: showAutoCompleteList,
        criteria: criteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList == true &&
      customerCode !== ""
    ) {
      setTimeout(() => {
        this.readCustomerBySearchString(e.target.value);
      }, 200);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ critera: tempCriteria });
  };
  readandsetCustomerDetail = (customerCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = customerCode;
    input.isLoadChildren = true;
    CustomerService.readCustomer(
      input,
      this.readandsetCustomerDetailResponse,
      this.errorCallBack
    );
  };
  readandsetCustomerDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      if (!isEmpty(customerData)) {
        criteria.customerName = customerData.description;
        criteria.customerCode = customerData.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let customer_pageList = new RestPageListBean();
    customer_pageList.pageSize = 10;
    let customer_requestInput = new RestCustomerListRequest();
    customer_requestInput.pageInput = customer_pageList;
    customer_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      customer_requestInput,
      this.readByCustomerCodeResponse,
      this.errorCallBack
    );
  }
  readByCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readandsetCustomerDetail(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCustomerList: showAutoCompleteList });
  };
  viewFabricModule = (e,code,rowData) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowFabricStyleModule: true,
        moduleForPopup: (
          <PopupFabricModule
            fabricStyleCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  viewPickTicketModule = (e,code,rowData) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowPickTicketModule: true,
        moduleForPopup: (
          <PopupPickTicketModule
            pickTicketCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  viewCustomerModule = (e,code,rowData) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowCustomerModule: true,
        moduleForPopup: (
          <PopupCustomerModule
            customerCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  viewSalesOrderModule = (e,code,rowData) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowSalesModule: true,
        moduleForPopup: (
          <PopupSalesModule code={code} onModuleExit={this.onPopupModalExit} />
        ),
      });
    }
  };
    columnDefinitions_V1= () => {
        const columns = new Array();
    
        columns.push(
          new ColumnDefinition()
            .setDetails("Print", "isActive", false)
            .setInputDetails(
              false,
              false,
              true,
              null,
              this.rollLineCheck,
              null,
            )
            .setStyleDetails("", "", "", "wt-1-5 ", "wt-1-5 "),
        );
        columns.push(
          new ColumnDefinition()
            .setDetails(
              "PickTicket" , "pickTicketNumber",
              true,
            )
             .setClickDetails(true, false, this.viewPickTicketModule, null)
            .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
        );

          columns.push(
          new ColumnDefinition()
            .setDetails("PickTicketDate", "pickTicketDate", true,false,true)
            .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
        );
        columns.push(
          new ColumnDefinition()
            .setDetails("Customer", "customerCode", true)
            .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
            .setClickDetails(true, false, this.viewCustomerModule, null)
        );
        columns.push(
          new ColumnDefinition()
            .setDetails("CustomerName", "customerName", true)
            .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
        );
                columns.push(
          new ColumnDefinition()
            .setDetails("SalesOrder", "salesOrderNumber", true)
            .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
            .setClickDetails(true, false, this.viewSalesOrderModule, null)
        );
        columns.push(
          new ColumnDefinition()
            .setDetails( this.state.is3PL ? "Item" : "FabricStyle",
          "fabricStyleCode", true)
             .setClickDetails(true, false, this.viewFabricModule, null)
            .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
        );

                     columns.push(
          new ColumnDefinition()
            .setDetails("Name", "fabricStyleName", true)
            .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
        );

                            columns.push(
          new ColumnDefinition()
            .setDetails("Color", "colorCode", true)
            .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
        );

                                    columns.push(
          new ColumnDefinition()
            .setDetails("SKU", "skuNumber", true)
            .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
        );

                                            columns.push(
          new ColumnDefinition()
            .setDetails("Picker", "pickedUpBy", true)
            .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
        );
         
  
             columns.push(
          new ColumnDefinition()
            .setDetails("Quantity", "toBePickedQuantity", true,true)
            .setStyleDetails("right", "", "", "wt-4 ", "wt-4 "),
        );
  
                     columns.push(
          new ColumnDefinition()
            .setDetails("OrderStopDate", "orderStopDate", true,false,true)
            .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
        );      
     
     
     
    
        return columns;
      };
      // getCaption = (status) => {
      //   return ModuleUtils.getSalesCommisionTransactionStatusCaption(status);
      // };
  // columnDefinitions = () => {
  //   let columnList = [];
  //   columnList.push(
  //     new DataGridColumnDefinition()
  //       .setDetails("Print", "isActive", 0, false, null, false, null)
  //       .setEditableDetails(
  //         false,
  //         "",
  //         null,
  //         false,
  //         null,
  //         true,
  //         this.rollLineCheck
  //       )
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "PickTicket",
  //       "pickTicketNumber",
  //       0,
  //       true,
  //       this.viewPickTicketModule
  //     )
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "PickTicketDate",
  //       "pickTicketDate"
  //     )
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "Customer",
  //       "customerCode",
  //       0,
  //       true,
  //       this.viewCustomerModule
  //     )
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("CustomerName", "customerName")
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "SalesOrder",
  //       "salesOrderNumber",
  //       0,
  //       true,
  //       this.viewSalesOrderModule
  //     )
  //   );
  //   if (this.state.is3PL) {
  //     columnList.push(
  //       new DataGridColumnDefinition().setDetails(
  //         "Item",
  //         "fabricStyleCode",
  //         0,
  //         true,
  //         this.viewFabricModule
  //       )
  //     );
  //   } else {
  //     columnList.push(
  //       new DataGridColumnDefinition().setDetails(
  //         "Fabricstyle",
  //         "fabricStyleCode",
  //         0,
  //         true,
  //         this.viewFabricModule
  //       )
  //     );
  //   }
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("Name", "fabricStyleName")
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("Color", "colorCode")
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("SKU", "skuNumber", 1)
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("Picker", "pickedUpBy")
  //   );

  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "Quantity",
  //       "toBePickedQuantity",
  //       1
  //     )
  //   );

  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "OrderStopDate",
  //       "orderStopDate"
  //     )
  //   );

  //   return columnList;
  // };


  rollLineCheck = (e, rowData) => {
  const checked = e.target.value;

  const pickTicketDataList = [
    ...this.state.pickTicketDataList
  ];

  const selectedLineList = [
    ...this.state.selectedLineList
  ];

  // Find the selected row in the main list
  const index = pickTicketDataList.findIndex(
    (item) => item.pickTicketNumber === rowData.pickTicketNumber
  );

  if (index > -1) {

    // Update only the selected row
    pickTicketDataList[index].isActive = checked;

if (checked) {

  // Add to selected list if not already selected
  if (
    !selectedLineList.some(
      (item) =>
        item.pickTicketNumber === rowData.pickTicketNumber
    )
  ) {
    selectedLineList.push(
      pickTicketDataList[index]
    );
  }

} else {

  // Remove from selected list using both conditions
  const selectedIndex = selectedLineList.findIndex(
    (item) =>
      item.pickTicketNumber === rowData.pickTicketNumber
  );

  if (selectedIndex > -1) {
    selectedLineList.splice(selectedIndex, 1);
  }
}
  }

  this.setState({
    pickTicketDataList,
    selectedLineList,
  });

 // this.calculateTotals(selectedItemList);
};
  // rollLineCheck = (val, rowData) => {
  //   let selectedLine = this.state.selectedLineList;
  //   if (rowData.isActive === true) {
  //     selectedLine.push(rowData);
  //     this.setState({ selectedLineList: selectedLine });
  //   } else {
  //     let selectedLineList = this.state.selectedLineList;
  //     let rollList = [];
  //     for (let roll of selectedLineList) {
  //       if (roll.isActive != rowData.isActive) {
  //         rollList.push(roll);
  //         this.setState({ selectedLineList: rollList });
  //       } else if (selectedLineList.length == 1) {
  //         this.setState({ selectedLineList: [] });
  //       }
  //     }
  //   }
  // };
  lineSelectAll = () => {
    let list = this.state.pickTicketDataList;
    list.map((line) => {
      line.isActive = true;
    });
    this.setState({ selectedLineList: list });
  };
  lineUnSelectAll = () => {
    let list = this.state.pickTicketDataList;
    list.map((line) => {
      line.isActive = false;
    });
    this.setState({ selectedLineList: [] });
  };
  print = (e) => {
    if (e.detail == 1) {
      let selectedLineList = this.state.selectedLineList;
      if (!isEmptyArray(selectedLineList)) {
        this.generateReport();
      } else {
        this.inValidAccess(3);
      }
    }
  };
  generateReport = () => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating ...",
    });
    let tempCriteria = this.state.criteria;
    tempCriteria.companyCode = this.companyCode;
    let selectedLineList = this.state.selectedLineList;
    let rollSkuList = [];
    for (let list of selectedLineList) {
      let infoBean = new PullBulkPickTicketInfoBean();
      infoBean.companyCode = list.companyCode;
      infoBean.isPickSelectedFlag = list.isActive;
      infoBean.salesOrderNumber = list.salesOrderNumber;
      infoBean.pickTicketDate = list.pickTicketDate;
      infoBean.customerCode = list.customerCode;
      infoBean.customerName = list.customerName;
      infoBean.fabricStyleCode = list.fabricStyleCode;
      infoBean.fabricStyleName = list.fabricStyleName;
      infoBean.colorCode = list.colorCode;
      infoBean.toBePickedQuantity = list.toBePickedQuantity;
      infoBean.uomCode = list.uomCode;
      infoBean.skuNumber = list.skuNumber;
      infoBean.pickedUpBy = list.pickedUpBy;
      infoBean.orderStartDate = list.orderStartDate;
      infoBean.orderStopDate = list.orderStopDate;
      infoBean.pickTicketNumber = list.pickTicketNumber;
      rollSkuList.push(infoBean);
    }
    let criteria = new PullBulkPickTicketSummaryResultBean();
    criteria.companyCode = this.companyCode;
    criteria.openPickTicketInfos = rollSkuList;
    let reportBean = new RestReportBean();
    reportBean.reportType = 1;
    let listRequest = new PullBulkPickTicketSummaryInquiryDetailRequest();
    listRequest.criteria = tempCriteria;
    listRequest.input = reportBean;
    listRequest.resultBean = criteria;
    if (SecurityAccessManager.BulkPickTicketInquiry_IsAccessible()) {
      ReportService.generatePullBulkPickTicketSummaryInquiryDetailReport(
        listRequest,
        this.generatePullBulkPickTicketpageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  generatePullBulkPickTicketpageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    // let selectedLineList = new Array();
    this.setState({
      // selectedLineList: selectedLineList,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  render() {
    let pickTicketDataList = this.state.pickTicketDataList;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          hideAlertCallBack={this.hideAlertCallBack}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowExitButton={this.state.isShowExitButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          clearCriteria={this.clearCriteria}
          onModuleExit={this.onModuleExit}
          reset={this.reset}
          extend_toolbar={
            <>
              {this.state.isShowPrintButton && (
                <Button
                  className="header_buttons secondary"
                  size="sm"
                  onClick={(e) => this.print(e)}
                >
                  Print
                </Button>
              )}
              {this.state.isShowFetchButton && (
                <Button
                  className="header_buttons secondary"
                  size="sm"
                  onClick={(e) => this.fetch(e)}
                >
                  Fetch
                </Button>
              )}
            </>
          }
        />
        <CriteriaView
          {...this.state}
          onChange={this.onChange}
          fabricCodeOnChange={this.fabricCodeOnChange}
          fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
          displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
          fabricColourEnterKeyEventHandler={
            this.fabricColourEnterKeyEventHandler
          }
          displayAutoCompleteFabricColorList={
            this.displayAutoCompleteFabricColorList
          }
          onFabricColourCodeChange={this.onFabricColourCodeChange}
          customerCodeOnChange={this.customerCodeOnChange}
          customerCodeEnterKeyEventHandler={
            this.customerCodeEnterKeyEventHandler
          }
          displayAutoCompleteList={this.displayAutoCompleteList}
          lineSelectAll={this.lineSelectAll}
          lineUnSelectAll={this.lineUnSelectAll}
        />

        {this.state.isPickTicketDatasFound && (
          <>
            {/* <Row>
              <FormLabel className="table_title">Pickticket DataList</FormLabel>
            </Row> */}

               <div className="mt-3">
                      <CustomTable
                        data={pickTicketDataList}
                        columns={this.columnDefinitions_V1()}
                        label={"Pickticket DataList"}
                      // isSortedData={true}
                      // label={
                      //   this.state.is3PL ? "Choose Inventory Lines" : "RollLines"
                      // }
                      // onSortComplete={(sortedData, sortConfig) => {
                      //   this.setState({ pt_rollLines: sortedData });
                      // }}
                      />
                    </div>
            {/* <div className="div_default">
              <EditableDataGrid
                columnsList={this.columnDefinitions()}
                dataList={pickTicketDataList}
              />
            </div> */}
          </>
        )}

        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowFabricStyleModule}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel1"}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>

        <MultiViewPopup
          isModulePopup={true}
          isShowPopup={this.state.isShowCustomerModule}
          id="moduleForPopup"
          popupLvlClass={"popupSizeLevel1"}
          closeOnEsc={false}
          module={this.state.moduleForPopup}
          closeModalCallBack={this.closeModalCallBack}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          isShowPopup={this.state.isShowSalesModule}
          id="moduleForPopup"
          popupLvlClass={"popupSizeLevel1"}
          closeOnEsc={false}
          module={this.state.moduleForPopup}
          closeModalCallBack={this.closeModalCallBack}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          isShowPopup={this.state.isShowPickTicketModule}
          id="moduleForPopup"
          popupLvlClass={"popupSizeLevel1"}
          closeOnEsc={false}
          module={this.state.moduleForPopup}
          closeModalCallBack={this.closeModalCallBack}
        ></MultiViewPopup>
      </div>
    );
  }
}
export function CriteriaView(props) {
  const onChange = (e) => props.onChange(e);
  const customerCodeOnChange = (e) => {
    props.customerCodeOnChange(e);
  };
  const fabricCodeOnChange = (e) => {
    props.fabricCodeOnChange(e);
  };
  const onFabricColourCodeChange = (e) => {
    props.onFabricColourCodeChange(e);
  };
  const customerCodeEnterKeyEventHandler = (e) => {
    props.customerCodeEnterKeyEventHandler(e);
  };
  const fabricEnterKeyEventHandler = (e) => {
    props.fabricEnterKeyEventHandler(e);
  };
  const fabricColourEnterKeyEventHandler = (e) => {
    props.fabricColourEnterKeyEventHandler(e);
  };
  const displayAutoCompleteList = () => {
    props.displayAutoCompleteList();
  };
  const displayAutoCompleteFabricList = () => {
    props.displayAutoCompleteFabricList();
  };
  const displayAutoCompleteFabricColorList = () => {
    props.displayAutoCompleteFabricColorList();
  };
  const lineSelectAll = (e) => {
    if (e.detail == 1) props.lineSelectAll();
  };
  const lineUnSelectAll = (e) => {
    if (e.detail == 1) props.lineUnSelectAll();
  };
  let customerLookupHandler = props.customerLookupHandler;
  let fabricLookupHandler = props.fabricLookupHandler;
  const customerCodeRef = props.customerCodeRef;
  let fabricCodeRef = React.createRef();
  let colorCodeRef = React.createRef();
  let criteria = props.criteria;

  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          {props.is3PL ? (
            <FormLabel>Item</FormLabel>
          ) : (
            <FormLabel>FabricSTyle</FormLabel>
          )}
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={fabricCodeRef}
            name="fabricStyleCode"
            onChange={fabricCodeOnChange}
            value={criteria.fabricStyleCode}
            lookupRequired={props.isShowLookup}
            lookupHandler={fabricLookupHandler}
            showCriteriaDialog={true}
            enterKeyEventHandler={fabricEnterKeyEventHandler}
            autoCompleteListData={props.fabricPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteFabricList}
            showAutoCompleteList={props.showAutoCompleteFabricList}
            disabled={props.isDisableFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="2">
          <InputTextbox
            name="fabricStyleName"
            onChange={onChange}
            value={criteria.fabricStyleName}
            disabled={true}
          />
        </Col>

        <Col sm="1">
          <FormLabel>Color</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={colorCodeRef}
            onChange={onFabricColourCodeChange}
            name="fabricStyleColorCode"
            placeholder="color"
            value={criteria.fabricStyleColorCode}
            lookupRequired={props.isShowColorLookup}
            lookupHandler={props.colorLookupHandler}
            enterKeyEventHandler={fabricColourEnterKeyEventHandler}
            autoCompleteListData={props.fabricColourPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteFabricColorList}
            showAutoCompleteList={props.showAutoCompleteFabricColorList}
            disabled={props.isDisableFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="1">
          <FormLabel>Pack Status</FormLabel>
        </Col>
        <Col sm="2">
          <FormControl
            as="select"
            onChange={onChange}
            name="pickTicketSelectionStatus"
            value={criteria.pickTicketSelectionStatus}
            disabled={props.isDisableFields}
          >
            <option value={"0"}>All</option>
            <option value={"1"}>Packed</option>
            <option value={"2"}>UnPacked</option>
          </FormControl>
        </Col>
      </Row>
      <div>
        <Row>
          <Col sm="1">
            <FormLabel>Customer</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              ref={customerCodeRef}
              name="customerCode"
              onChange={customerCodeOnChange}
              lookupRequired={props.isShowLookup}
              value={criteria.customerCode}
              lookupHandler={customerLookupHandler}
              enterKeyEventHandler={customerCodeEnterKeyEventHandler}
              autoCompleteListData={props.customerPageListForAutoCompleteList}
              displayAutoCompleteList={displayAutoCompleteList}
              enableAutoCompleteTextBox={true}
              showAutoCompleteList={props.showAutoCompleteCustomerList}
              disabled={props.isDisableFields}
              isMandatory={true}
            />
          </Col>
          <Col sm="2">
            <InputTextbox
              name="customerName"
              onChange={onChange}
              value={criteria.customerName}
              disabled={true}
            />
          </Col>

          <Col sm="1">
            <FormLabel>From Picked Date</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent
              name="fromPickedDate"
              value={criteria.fromPickedDate}
              onChange={onChange}
              disabled={props.isDisableFields}
            />
          </Col>
          <Col sm="1">
            <FormLabel>To Picked Date</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent
              name="toPickedDate"
              value={criteria.toPickedDate}
              onChange={onChange}
              disabled={props.isDisableFields}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>Picker</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="pickerName"
              placeholder="picker"
              value={criteria.pickerName}
              onChange={onChange}
              disabled={props.isDisableFields}
              isMandatory={true}
            />
          </Col>
          <Col sm="2"></Col>
          <Col sm="1">
            <FormLabel>From Order Stop Date</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent
              name="fromOrderStopDate"
              value={criteria.fromOrderStopDate}
              onChange={onChange}
              disabled={props.isDisableFields}
            />
          </Col>
          <Col sm="1">
            <FormLabel>To Order Stop Date</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent
              name="toOrderStopDate"
              value={criteria.toOrderStopDate}
              onChange={onChange}
              disabled={props.isDisableFields}
            />
          </Col>
        </Row>
      </div>
      {props.isShowSelectButton && (
        <>
          <Row>
            <Col sm="1">
              <FormLabel className="label_head">Pick Tickets </FormLabel>
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <Button
                size="sm"
                id="fabric_Add_Button"
                onClick={(e) => lineSelectAll(e)}
              >
                Select All{" "}

              </Button>
            </Col>
            <Col sm="1">
              <Button
                size="sm"
                id="fabric_Add_Button"
                onClick={(e) => lineUnSelectAll(e)}
              >
                UnSelect All{" "}
              </Button>
            </Col>
          </Row>
        </>
      )}
    </div>
  );
}

function PrintBulkPickTicketMaintenance(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App"></div>
      <PrintBulkPickTicketMaintenanceDetails {...props} name="" />
      <br />
    </div>
  );
}
export default PrintBulkPickTicketMaintenance;
